import axios from 'axios';

import { downloadDocument } from './downloadDocument';
import store from '../store';
import { enqueueSnackbar } from '../redux/notifier/notifierActions';

async function exportTextMessages(messages, options = {}) {
  const { fileName = 'FileName.txt' } = options;

  if (!Array.isArray(messages) || messages.length === 0 || messages.some((m) => typeof m !== 'string')) {
    store.dispatch(
      enqueueSnackbar({
        message: 'couldntExportRecords',
        options: { variant: 'error' },
      }),
    );
    return;
  }

  try {
    const response = await axios.request({
      url: `/api/util/export`,
      method: 'POST',
      responseType: 'blob',
      data: messages,
    });

    downloadDocument(fileName, response.data);
  } catch (error) {
    console.error(error);
    store.dispatch(
      enqueueSnackbar({
        message: 'couldntExportRecords',
        options: {
          variant: 'error',
        },
      }),
    );
  }
}

export default exportTextMessages;
